import {httpService} from "@/modules/common/services";


const fetchMeetings = async (start, end) => {
  const data = {
    start: start || new Date(2022, 5, 20),
    end: end || new Date(2022, 5, 26),
    // staff_uids: staffUids.join(', ')
    new_calendar: true
  }
  return await httpService.get('calendar/items', data)
}

export const schedulerService = {
  fetchMeetings,
}
